import axios from "axios";
import { AUTH_API } from "./common_api";
const API_BASE = AUTH_API;

/* =========================
   🔹 GET DROPDOWN DATA
========================= */
export async function fetchRolesAPI() {
  const res = await axios.get(`${API_BASE}/roles`);
  return res.data;
}

export async function fetchManagersAPI() {
  const res = await axios.get(`${API_BASE}/reporting_managers`);
  return res.data;
}

export async function fetchSBUHeadsAPI() {
  const res = await axios.get(`${API_BASE}/sbu_heads`);
  return res.data;
}

/* =========================
   🔹 REGISTER USER
========================= */
export async function registerUserAPI(form) {
  const fd = new FormData();
  Object.entries(form).forEach(([k, v]) => fd.append(k, v));

  const res = await axios.post(`${API_BASE}/register`, fd);
  return res.data;
}
